module.exports = __webpack_public_path__ + "3af69be8fcbdb6eaaccd559f436f43a7.MP3";